import CountyForm from "./CountyForm";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { fetchWithExtraOptions, tgxApi } from "../../../app/tgxApi";
import { useGetCountyByIdQuery } from "./countiesApi";
import Preloader from "../../../components/common/Preloader";

const UpdateCounty = () => {

    let { countyId } = useParams();
    // @ts-ignore
    fetchWithExtraOptions(tgxApi.endpoints.getCountyById, { countyId }, {
        redirectToErrorPage: true,
        skip: !countyId
    });
    const countyByIdApi = useGetCountyByIdQuery(countyId);
    const [crumbs, setCrumbs] = useState<any[]>([]);

    useEffect(() => {
        let countyObj = countyByIdApi?.data;
        if (countyObj) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Counties", url: "/counties" },
                { content: "Update County", url: "" }
            ]);

            document.title = `Update County`;
        }
    }, [countyByIdApi?.data]);

    return (
        <>
            {countyByIdApi.data === undefined || countyByIdApi?.data?.id === undefined
                ? <Preloader />
                :
                <CountyForm crumbs={crumbs} title={"Update County"} btnText={"Update"}
                    isReadOnly={hasPermission(["COUN-U"]) === false} />
            }

        </>
    )
}
export default UpdateCounty;